/**
 * Global Vue JS Mixin
 * - beforeMount
 * - EpiLang
 *
 * @type {Object}
 */

import * as breakpoints from './global-breakpoints'
import * as history from './global-history';
import './global-prototypes-enhancements'
import Vue from 'vue'

/* FONTS */
import 'typeface-lato'

/* ICONS */
import 'material-icons'

// Create vue component to update breakpoint and orientation on event changes
// using vue component reactivity
const reactorComponent = new Vue({
    data () {
        return {
            currentBreakpoint: null,
            currentOrientation: null
        }
    }
})

// Manage device && orientation with events
const mediaQueries = () => {
    const updateCurrentBreakpoint = () => {
        let width = window.innerWidth

        if (width < breakpoints.BREAKPOINT_TABLET_WIDTH) {
            reactorComponent.currentBreakpoint = breakpoints.BREAKPOINT_PHONE
        } else if (width < breakpoints.BREAKPOINT_DESKTOP_WIDTH) {
            reactorComponent.currentBreakpoint = breakpoints.BREAKPOINT_TABLET
        } else {
            reactorComponent.currentBreakpoint = breakpoints.BREAKPOINT_DESKTOP
        }
    }

    const updateCurrentOrientation = (angle) => {
        if (angle === 0) {
            reactorComponent.currentOrientation = breakpoints.BREAKPOINT_PORTRAIT
        } else {
            reactorComponent.currentOrientation = breakpoints.BREAKPOINT_LANDSCAPE
        }
    }

    window.addEventListener('resize', (event) => {
        updateCurrentBreakpoint()
        updateCurrentOrientation(event.target.screen.orientation.angle)
    })

    updateCurrentBreakpoint()
    updateCurrentOrientation(0)
}

mediaQueries()

export const globalMixin = {
    beforeMount() {
        const {asyncData} = this.$options;
        if (asyncData) {
            this.dataPromise = asyncData({
                store: this.$store,
                route: this.$route
            });
        }
    },
    computed: {
        $_globalMixin_currentBreakpoint () {
            return reactorComponent.currentBreakpoint
        },
        $_globalMixin_currentOrientation () {
            return reactorComponent.currentOrientation
        }
    },
    mounted () {
        const title = this.getPageTitle(this)
        if (title) {
            document.title = title
        }
    },
    methods: {
        addHistoryHit () {
            history.addHistoryHit()
        },
        cleanHistory () {
            history.cleanHistory()
        },
        getAsset (path) {
           return process.env.VUE_APP_CDN_URL ? process.env.VUE_APP_CDN_URL + path : path
        },
        getLastHit () {
            return history.getLastHit()
        },
        getLocale (locale) {
            return this.$t(locale)
        },
        getPageTitle (vm) {
            const { title } = vm.$options
            if (title) {
                return this.getLocale(title)
            }
        },
        getLocalizedRoute (route, lang = null) {
            if (lang === null) {
                lang = this.$i18n.locale
            }
            if (route.name && route.name.indexOf(lang === -1)) {
                route.name = lang + '.' + route.name
            }
            if (route.params && typeof route.params === 'object' && !route.params.locale) {
                route.params.locale = lang
            } else {
                route.params = {
                    locale: lang
                }
            }

            return route
        },
        popPreviousHit () {
            return history.popPreviousHit()
        },
        setI18nLanguage (lang) {
            this.$i18n.locale = lang
            document.documentElement.setAttribute('lang', lang)
        },
        updateLastHit () {
            history.updateLastHit()
        }
    }
}
